import {
  BrainCircuit,
  Sparkles,
  LineChart,
  Gauge,
  ShieldCheck,
  BellRing,
} from "lucide-react";

const features = [
  {
    icon: BrainCircuit,
    title: "AI Health Risk Analysis",
    desc: "Advanced AI models detect subtle patterns across your health and lifestyle inputs.",
    span: "md:col-span-2",
  },
  {
    icon: Sparkles,
    title: "Personalized Wellness Suggestions",
    desc: "Tailored recommendations that adapt to your unique profile — not generic advice.",
  },
  {
    icon: LineChart,
    title: "Lifestyle Insights",
    desc: "Understand how sleep, activity, and habits shape your long-term wellness.",
  },
  {
    icon: Gauge,
    title: "Easy-to-Understand Score",
    desc: "A clear single number & breakdown, so anyone can grasp their wellness at a glance.",
  },
  {
    icon: BellRing,
    title: "Preventive Awareness",
    desc: "Timely nudges that encourage healthier decisions before issues escalate.",
  },
  {
    icon: ShieldCheck,
    title: "Privacy-Focused Design",
    desc: "Your data is treated with the utmost care. Encryption at every step of the way.",
    span: "md:col-span-2",
  },
];

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400">
            Capabilities / 03
          </p>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">
            Built for meaningful health awareness.
          </h2>
          <p className="mt-5 text-lg text-zinc-400 max-w-2xl">
            A quietly powerful set of features to help you understand your body
            before symptoms speak up.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-card-${i}`}
              className={`relative group glass-card rounded-3xl p-8 overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:border-cyan-400/30 ${f.span || ""}`}
            >
              {/* Hover glow */}
              <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-cyan-500/10 blur-[60px] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#0B3D91]/60 to-cyan-500/20 border border-white/10 flex items-center justify-center">
                  <f.icon className="w-6 h-6 text-cyan-300" strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold text-white tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-3 text-zinc-400 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
